<template>
	<div class="popToast-container">
		<div class="centerContent">
			<img class="sucIcon" :src="imgPtahUrl" />
			<div class="title" v-if="desc">
				{{desc}}
			</div>
			<div class="titleTwo" v-if="descTwo">
				{{descTwo}}
			</div>
			<div class="subTitle" v-if="subTitle">
				{{subTitle}}
			</div>
			<div class="ok" @click="clickOk">
				{{btnTitle}}
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'PopToast',
		props: {
			// 路径
			imgPtahUrl: {
				type: String,
				default: ''
			},
			// 描述
			desc: {
				type: String,
				default: ''
			},
			descTwo: {
				type: String,
				default: ''
			},
			subTitle: {
				type: String,
				default: ''
			},
			btnTitle: {
				type: String,
				default: '好的'
			},
		},
		data() {
			return {}
		},
		methods: {
			clickOk() {
				this.$emit('clickOk', {})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.popToast-container {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0, 0, 0, 0.5);
		z-index: 103;

		.centerContent {
			display: flex;
			flex-direction: column;
			width: 3.1rem;
			background: #FFFFFF;
			border-radius: .12rem;
			padding: 0 .24rem;

			.sucIcon {
				width: .64rem;
				height: .64rem;
				margin: .4rem auto 0;
			}

			.title {
				margin: .24rem .24rem 0;
				font-weight: 500;
				font-size: .16rem;
				color: #252525;
				text-align: center;
			}
			
			.titleTwo{
				margin: 0 auto;
				font-weight: 500;
				font-size: .16rem;
				color: #252525;
				text-align: center;
			}
			
			.subTitle {
				margin: .08rem auto 0;
				max-width: 2rem;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
				text-align: center;
			}

			.ok {
				margin: .24rem auto .32rem;
				width: 1.76rem;
				height: .36rem;
				background: #E29358;
				border-radius: .04rem;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
				text-align: center;
				line-height: .36rem;
				cursor: pointer;
			}
		}
	}
</style>